export function maskText(dataString = "", index) {
  let data = dataString?.replace(/\s/g, "");
  let result = "";
  if (data) {
    while (data.length > 0) {
      result = `${result} ${data.substring(0, index)}`.trim();
      data = data.substring(index);
    }
    return result.toUpperCase();
  }
  return result;
}
